import translate from '@allesauto/i18n';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { requestVehicleValidation } from '@/features/whitelabel/validation/requestVehicleValidation';

export const useTranslationOrderVehicleForm = () => {
  const intl = useIntl();

  const memoizedOrderVehicleContactFormSchema = useMemo(() => {
    const validationMsgs = {
      lastName: {
        format: translate(
          intl,
          'ui.FORMS.VALIDATION_MESSAGES.STRING.ONLY_LETTERS'
        ),
        required: translate(intl, 'ui.FORMS.VALIDATION_MESSAGES.REQUIRED'),
        minLength: translate(intl, 'ui.FORMS.VALIDATION_MESSAGES.STRING.MIN'),
        maxLength: translate(intl, 'ui.FORMS.VALIDATION_MESSAGES.STRING.MAX'),
      },
      firstName: {
        format: translate(
          intl,
          'ui.FORMS.VALIDATION_MESSAGES.STRING.ONLY_LETTERS'
        ),
        required: translate(intl, 'ui.FORMS.VALIDATION_MESSAGES.REQUIRED'),
        minLength: translate(intl, 'ui.FORMS.VALIDATION_MESSAGES.STRING.MIN'),
        maxLength: translate(intl, 'ui.FORMS.VALIDATION_MESSAGES.STRING.MAX'),
      },
      email: {
        format: translate(intl, 'ui.FORMS.VALIDATION_MESSAGES.STRING.EMAIL'),
        required: translate(intl, 'ui.FORMS.VALIDATION_MESSAGES.REQUIRED'),
      },
      phone: {
        required: translate(intl, 'ui.FORMS.VALIDATION_MESSAGES.REQUIRED'),
        minLength: translate(intl, 'ui.FORMS.VALIDATION_MESSAGES.STRING.MIN'),
        maxLength: translate(intl, 'ui.FORMS.VALIDATION_MESSAGES.STRING.MAX'),
      },
    };
    return requestVehicleValidation(validationMsgs);
  }, [intl]);

  const memoizedOrderVehicleFormTranslations = useMemo(
    () => ({
      TITLE: translate(intl, 'ui.FORMS.CONTACT_DEALER.TITLE'),
      USER_MSG_LABEL: translate(intl, 'ui.FORMS.CONTACT_DEALER.USER_MSG_LABEL'),
      EMAIL_LABEL: translate(intl, 'ui.FORMS.CONTACT_DEALER.EMAIL'),
      FIRST_NAME: translate(intl, 'ui.FORMS.CONTACT_DEALER.FIRST_NAME'),
      LAST_NAME: translate(intl, 'ui.FORMS.CONTACT_DEALER.LAST_NAME'),
      PHONE: translate(intl, 'ui.FORMS.CONTACT_DEALER.PHONE'),
      REQUIRED_FIELD_NOTE: translate(
        intl,
        'ui.FORMS.COMMON.REQUIRED_FIELD_NOTE'
      ),
      BUTTON_TEXT: translate(intl, 'ui.FORMS.CONTACT_DEALER.BUTTON_TEXT'),
    }),
    [intl]
  );

  return {
    memoizedOrderVehicleContactFormSchema,
    memoizedOrderVehicleFormTranslations,
  };
};

export default useTranslationOrderVehicleForm;
